'use client'

import { sendGAEvent } from '@next/third-parties/google'

// Conversion-IDs kommen aus Vercel-Env-Variablen; ohne gesetzten Wert wird der
// jeweilige Kanal still übersprungen (kein Platzhalter-Traffic mehr).
const GOOGLE_ADS_ID = process.env.NEXT_PUBLIC_GOOGLE_ADS_ID
const GOOGLE_ADS_LEAD_LABEL = process.env.NEXT_PUBLIC_GOOGLE_ADS_LEAD_LABEL
const LINKEDIN_CONVERSION_ID = process.env.NEXT_PUBLIC_LINKEDIN_CONVERSION_ID

export function trackEvent(name: string, params: Record<string, string | number | boolean> = {}) {
  try {
    sendGAEvent('event', name, params)
  } catch {
    // Analytics darf nie die UI brechen
  }
}

/** Klick auf einen Calendly-CTA (noch keine Buchung). */
export function trackCalendlyClick(source: string) {
  trackEvent('calendly_click', { source })
}

/**
 * Tatsächlich gebuchter Calendly-Termin (calendly.event_scheduled),
 * das eigentliche Conversion-Ereignis des Haupt-Funnels.
 */
export function trackCalendlyBooked(source: string) {
  trackEvent('calendly_booked', { source })
  fireAdsConversions(source)
}

/** Erfolgreich abgeschicktes Lead-/Kontaktformular. */
export function trackLeadFormSubmit(source: string) {
  trackEvent('lead_form_submit', { source })
  fireAdsConversions(source)

  if (window.fbq) {
    window.fbq('track', 'Lead', {
      content_name: source,
      content_category: 'Lead Generation'
    })
  }
}

function fireAdsConversions(source: string) {
  if (GOOGLE_ADS_ID && GOOGLE_ADS_LEAD_LABEL && window.gtag) {
    window.gtag('event', 'conversion', {
      send_to: `${GOOGLE_ADS_ID}/${GOOGLE_ADS_LEAD_LABEL}`,
      value: 1.0,
      currency: 'EUR',
      event_source: source
    })
  }

  if (LINKEDIN_CONVERSION_ID && window.lintrk) {
    window.lintrk('track', { conversion_id: LINKEDIN_CONVERSION_ID })
  }
}
